export default {

	/**
	 * Wrapper for legacy of jons old happo paint game
	 * @type {{assetRes: number}}
	 */
	main: {assetRes: 1},

	/**
     * @static
     * @type {number}
     * @default 1664
     */
	STAGE_WIDTH: 1664,

	/**
     * @static
     * @type {number}
     * @default 768
     */
	STAGE_HEIGHT: 768,

	/**
     * @static
     * @type {object}
     */
	config: {},

	/**
     * @static
     * @type {object}
     */
	gameConfig: {},

	/**
	 * @static
	 * @type {object}
	 */
	levelConfig: {},

	/**
     * @static
     * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
     */
	renderer: null,

	/**
     * @static
     * @type {PIXI.Container}
     */
	stage: null,

	/**
     * @static
     * @type {P3.Ticker}
     */
	ticker: null,

	/**
     * @static
     * @type {PIXI.Container}
     */
	transitions: null,

	/**
	 * @static
	 * @type {SavedData}
	 */
	savedData: null,

	game: null,

	gameScene: null,

	createSprite: function(config) {
		const sprite = new PIXI.Sprite(P3.assets.texture(config.texture));
		config.hasOwnProperty('position') && (sprite.position.set(
			this.STAGE_WIDTH * 0.5 + config.position.x,
			this.STAGE_HEIGHT * 0.5 + config.position.y
		));
		config.hasOwnProperty('width') ? sprite.width = config.width : sprite.scale.set(config.scale.x, config.scale.y);
		config.hasOwnProperty('anchor') ? (sprite.anchor.set(config.anchor.x, config.anchor.y)) : sprite.anchor.set(0.5);
		config.hasOwnProperty('rotation') && (sprite.rotation = config.rotation * PIXI.DEG_TO_RAD);
		return sprite;
	},

	findPositionInScene: function(sprite, scene) {
		let result = new PIXI.Point(sprite.x, sprite.y);

		let parent = sprite.parent;
		while (parent !== scene) {
			result.x += parent.x;
			result.y += parent.y;

			parent = parent.parent;
		}

		return result;
	},

	hexToRgb: function(hex) {
		var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

		return result ? {
			r: parseInt(result[1], 16),
			g: parseInt(result[2], 16),
			b: parseInt(result[3], 16)
		} : null;
	},

	detectIE: function() {
		const ua = window.navigator.userAgent;
		const msie = ua.indexOf('MSIE ');
		if (msie > 0) {
			// IE 10 or older => return version number
			return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
		}

		const trident = ua.indexOf('Trident/');
		if (trident > 0) {
			// IE 11 => return version number
			const rv = ua.indexOf('rv:');
			return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
		}

		const edge = ua.indexOf('Edge/');
		if (edge > 0) {
			// Edge (IE 12+) => return version number
			return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
		}

		// other browser
		return false;
	}
};
